export class SiteHeader extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            header: "#shopify-section-header",
            headerNav: "[js-header-nav]",
        };
    }

    connectedCallback() {
        this.header = document.querySelector(this._selectors.header);
        this.headerNav = document.querySelector(this._selectors.headerNav);

        this._setVariables();
        this._watchWindowResize();
        this._setListeners();
    }

    _setListeners() {
        if (
            this.dataset.header === "fixed" &&
            window.location.pathname !== "/"
        ) {
            document.addEventListener("scroll", this._headerBackground);
        } else if (window.location.pathname === "/") {
            document.addEventListener("scroll", this._headerHeroBackground);
        } else {
            document.addEventListener("scroll", this._headerBackground);
        }
        // document.getElementById('MobileNavDrawer').addEventListener("open", this._reinitChoices);
        this._reinitChoices();
    }

    _watchWindowResize = (_evt) => {
        window.addEventListener("resize", this._setVariables);
    };

    _setVariables = (_evt) => {
        document.documentElement.style.setProperty(
            "--header-height",
            `${this.header.clientHeight}px`,
        );
    };

    _headerBackground = (_evt) => {
        var lastScrollTop = 0;
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            this.headerNav.classList.add("active");
        } else {
            this.headerNav.classList.remove("active");
        }
    };

    _headerHeroBackground = (_evt) => {
        const firstHero = document.querySelector('[id*="hero"]');
        if (firstHero) {
            const lastScrollTop = firstHero.clientHeight;
            const st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop - this.header.clientHeight) {
                this.headerNav.classList.add("active");
            } else {
                this.headerNav.classList.remove("active");
            }
        }
    };

    _reinitChoices() {
        const sSelect = document.querySelector("[js-country-selector-mobile]");

        this._waitForElm(".choices").then((_elm) => {
            const choices = sSelect.querySelector(".choices");
            const dropdown = sSelect.querySelector(
                ".choices__list.choices__list--dropdown",
            );

            choices.addEventListener("click", (event) => {
                console.log(event.currentTarget);
                event.stopPropagation();
                event.preventDefault();
                if (choices.classList.contains("is-open")) {
                    choices.classList.remove("is-focused");
                    choices.classList.remove("is-open");
                    choices.ariaExpanded = "false";
                    dropdown.classList.remove("is-active");
                    dropdown.ariaExpanded = "false";
                } else {
                    choices.classList.add("is-focused");
                    choices.classList.add("is-open");
                    choices.ariaExpanded = "true";
                    dropdown.classList.add("is-active");
                    dropdown.ariaExpanded = "true";
                }
            });

            document
                .getElementById("MobileNavDrawer")
                .addEventListener("click", (event) => {
                    console.log(event.currentTarget);
                    choices.classList.remove("is-focused");
                    choices.classList.remove("is-open");
                    choices.ariaExpanded = "false";
                    dropdown.classList.remove("is-active");
                    dropdown.ariaExpanded = "false";
                });
        });
    }

    _waitForElm(selector) {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver((_mutations) => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }
}
